import React from 'react';
import PropTypes from 'prop-types';
const Files = ({ fillWhite = '#fff', fillGreen = '#14AE5C', fillBlack = '#224251', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={48} height={60} viewBox="0 0 48 60" fill="none" {...props}>
    <path
      fill={fillWhite}
      d="M40.799 3.6c0-.66-.54-1.2-1.2-1.2h-36c-.66 0-1.2.54-1.2 1.2v48c0 .66.54 1.2 1.2 1.2.66 0 1.2-.54 1.2-1.2V4.8h34.8c.66 0 1.2-.54 1.2-1.2Z"
    />
    <path
      fill={fillWhite}
      d="M3.6 55.2A3.603 3.603 0 0 1 0 51.6v-48C0 1.614 1.614 0 3.6 0h36c1.986 0 3.6 1.614 3.6 3.6s-1.614 3.6-3.6 3.6H7.2v44.4c0 1.986-1.614 3.6-3.6 3.6Z"
    />
    <path
      fill={fillWhite}
      d="M44.4 7.2h-36c-.66 0-1.2.54-1.2 1.2v48c0 .66.54 1.2 1.2 1.2h36c.66 0 1.2-.54 1.2-1.2v-48c0-.66-.54-1.2-1.2-1.2Zm-1.2 48H9.6V9.6h33.6v45.6Z"
    />
    <path
      fill={fillWhite}
      d="M44.4 60h-36a3.603 3.603 0 0 1-3.6-3.6v-48c0-1.986 1.614-3.6 3.6-3.6h36c1.986 0 3.6 1.614 3.6 3.6v48c0 1.986-1.614 3.6-3.6 3.6ZM12 52.8h28.8V12H12v40.8Z"
    />
    <path
      fill={fillWhite}
      d="M15.6 16.8h21.6c.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2H15.6c-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2Z"
    />
    <path
      fill={fillWhite}
      d="M37.2 19.2H15.6a3.603 3.603 0 0 1-3.6-3.6c0-1.986 1.614-3.6 3.6-3.6h21.6c1.986 0 3.6 1.614 3.6 3.6s-1.614 3.6-3.6 3.6ZM15.6 26.4h21.6c.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2H15.6c-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2Z"
    />
    <path
      fill={fillWhite}
      d="M37.2 28.8H15.6a3.603 3.603 0 0 1-3.6-3.6c0-1.986 1.614-3.6 3.6-3.6h21.6c1.986 0 3.6 1.614 3.6 3.6s-1.614 3.6-3.6 3.6ZM15.6 36h21.6c.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2H15.6c-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2Z"
    />
    <path
      fill={fillWhite}
      d="M37.2 38.4H15.6a3.603 3.603 0 0 1-3.6-3.6c0-1.986 1.614-3.6 3.6-3.6h21.6c1.986 0 3.6 1.614 3.6 3.6s-1.614 3.6-3.6 3.6ZM15.6 21.6h19.2c.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2H15.6c-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2Z"
    />
    <path
      fill={fillWhite}
      d="M34.8 24H15.6a3.603 3.603 0 0 1-3.6-3.6c0-1.986 1.614-3.6 3.6-3.6h19.2c1.986 0 3.6 1.614 3.6 3.6S36.786 24 34.8 24ZM37.198 48.001h-6c-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2h6c.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2Z"
    />
    <path
      fill={fillWhite}
      d="M37.2 52.8h-6a3.603 3.603 0 0 1-3.6-3.6c0-1.985 1.614-3.6 3.6-3.6h6c1.986 0 3.6 1.615 3.6 3.6 0 1.987-1.614 3.6-3.6 3.6ZM15.6 31.2h19.2c.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2H15.6c-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2Z"
    />
    <path
      fill={fillWhite}
      d="M34.8 33.6H15.6A3.603 3.603 0 0 1 12 30c0-1.986 1.614-3.6 3.6-3.6h19.2c1.986 0 3.6 1.614 3.6 3.6s-1.614 3.6-3.6 3.6ZM15.6 40.8h19.2c.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2H15.6c-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2Z"
    />
    <path
      fill={fillWhite}
      d="M34.8 43.2H15.6a3.603 3.603 0 0 1-3.6-3.6c0-1.986 1.614-3.6 3.6-3.6h19.2c1.986 0 3.6 1.614 3.6 3.6s-1.614 3.6-3.6 3.6Z"
    />
    <path fill={fillGreen} d="M39.602 3.6h-36v48h36v-48Z" />
    <path fill={fillWhite} d="M44.399 8.4h-36v48h36v-48Z" />
    <path
      fill={fillBlack}
      d="M40.8 3.6c0-.66-.54-1.2-1.2-1.2h-36c-.66 0-1.2.54-1.2 1.2v48c0 .66.54 1.2 1.2 1.2.66 0 1.2-.54 1.2-1.2V4.8h34.8c.66 0 1.2-.54 1.2-1.2Z"
    />
    <path
      fill={fillBlack}
      d="M44.4 7.2h-36c-.66 0-1.2.54-1.2 1.2v48c0 .66.54 1.2 1.2 1.2h36c.66 0 1.2-.54 1.2-1.2v-48c0-.66-.54-1.2-1.2-1.2Zm-1.2 48H9.6V9.6h33.6v45.6Z"
    />
    <path
      fill={fillBlack}
      d="M15.6 16.8h21.6c.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2H15.6c-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2ZM15.6 26.4h21.6c.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2H15.6c-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2ZM15.6 36h21.6c.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2H15.6c-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2ZM15.6 21.6h19.2c.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2H15.6c-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2ZM37.201 48h-6c-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2h6c.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2ZM15.6 31.2h19.2c.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2H15.6c-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2ZM15.6 40.8h19.2c.66 0 1.2-.54 1.2-1.2 0-.66-.54-1.2-1.2-1.2H15.6c-.66 0-1.2.54-1.2 1.2 0 .66.54 1.2 1.2 1.2Z"
    />
  </svg>
);

Files.propTypes = {
  fillWhite: PropTypes.string,
  fillGreen: PropTypes.string,
  fillBlack: PropTypes.string
};

export default Files;
